import _taggedTemplateLiteral from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n                box-sizing: border-box;\n                padding: 0 ", "px;\n                width: ", "%;\n                margin-left: ", "%;\n            "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n                display: flex;\n                flex-wrap: nowrap;\n                align-items: ", ";\n                margin: 0 -", "px;\n                padding: 0 ", "px;\n            "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled, { css } from 'styled-components';
var GAP = 32;
var COLUMNS_COUNT = 12;
export var Grid = styled.div(function (_ref) {
  var _ref$container = _ref.container,
      container = _ref$container === void 0 ? false : _ref$container,
      _ref$align = _ref.align,
      align = _ref$align === void 0 ? 'flex-start' : _ref$align,
      _ref$gutter = _ref.gutter,
      gutter = _ref$gutter === void 0 ? 0 : _ref$gutter,
      _ref$item = _ref.item,
      item = _ref$item === void 0 ? false : _ref$item,
      _ref$span = _ref.span,
      span = _ref$span === void 0 ? 1 : _ref$span,
      _ref$offset = _ref.offset,
      offset = _ref$offset === void 0 ? 0 : _ref$offset;

  if (container) {
    return css(_templateObject(), align, GAP / 2, gutter);
  }

  if (item) {
    return css(_templateObject2(), GAP / 2, 100 / COLUMNS_COUNT * span, 100 / COLUMNS_COUNT * offset);
  }

  return null;
});